module.exports = __webpack_public_path__ + "img/app1.4ae8b86c.jpg";